import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Chip,
  Divider,
  Card,
  CardContent,
  Stack,
} from '@mui/material';
import { Verified, VerifiedOutlined } from '@mui/icons-material';

const AcademicQuestionPaperDetails = ({ data }) => {
  if (!data) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Box>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Subject
            </Typography>
            <Typography variant="h6">{data.subject}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Standard
            </Typography>
            <Typography variant="h6">{data.standard}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" color="text.secondary">
              Maximum Marks
            </Typography>
            <Typography variant="body1">{data.maximumMarks || '-'}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" color="text.secondary">
              Academic Year
            </Typography>
            <Typography variant="body1">{data.academicYear}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" color="text.secondary">
              Status
            </Typography>
            <Stack direction="row" spacing={1}>
              <Chip
                icon={data.isVerified ? <Verified /> : <VerifiedOutlined />}
                label={data.isVerified ? 'Verified' : 'Not Verified'}
                color={data.isVerified ? 'success' : 'default'}
                variant={data.isVerified ? 'filled' : 'outlined'}
              />
              <Chip
                label={data.isActive ? 'Active' : 'Inactive'}
                color={data.isActive ? 'success' : 'error'}
                variant="outlined"
              />
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom>
              Teacher Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Teacher ID
                </Typography>
                <Typography variant="body1">{data.teacherId || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Teacher Name
                </Typography>
                <Typography variant="body1">{data.teacherName || '-'}</Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom>
              Master Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Master ID
                </Typography>
                <Typography variant="body1">{data.masterId || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Master Code
                </Typography>
                <Typography variant="body1">{data.masterCode || '-'}</Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom>
              Audit Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Created By
                </Typography>
                <Typography variant="body1">{data.createdBy || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Created At
                </Typography>
                <Typography variant="body1">{formatDate(data.createdAt)}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="text.secondary">
                  Updated At
                </Typography>
                <Typography variant="body1">{formatDate(data.updatedAt)}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {/* Questions List */}
      <Typography variant="h6" gutterBottom>
        Questions ({data.questionPapers?.length || 0})
      </Typography>
      <Grid container spacing={2}>
        {data.questionPapers?.map((question, index) => (
          <Grid item xs={12} key={index}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  Q{question.questionNumber || index + 1}: {question.question}
                </Typography>
                {question.answer && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    <strong>Answer:</strong> {question.answer}
                  </Typography>
                )}
                <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                  {question.maxMark && (
                    <Typography variant="caption" color="text.secondary">
                      Max Mark: {question.maxMark}
                    </Typography>
                  )}
                  {question.obtainedMark && (
                    <Typography variant="caption" color="text.secondary">
                      Obtained Mark: {question.obtainedMark}
                    </Typography>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AcademicQuestionPaperDetails;